import React, { useEffect, useState } from 'react';

import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import { Stripe } from '@stripe/stripe-js';
const baseUrl = process.env.REACT_APP_API_BASE_URL;

function Payment({
  stripePromise,
  price,
}: {
  stripePromise: Stripe | PromiseLike<Stripe | null> | null;
  price: number;
}) {
  const [clientSecret, setClientSecret] = useState('');

  useEffect(() => {
    // Create PaymentIntent as soon as the page loads
    fetch(`${baseUrl}/create-payment-intent?amount=${price}`)
      .then((res) => res.json())
      .then(({ clientSecret }) => setClientSecret(clientSecret));
  }, []);

  return (
    <>
      {clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm price={price} />
        </Elements>
      )}
    </>
  );
}

export default Payment;
